import React from 'react';
import moment from 'moment';
import LocalizationManager from '../../../utils/localization/localization';

const ModernAbout = () => {
  const yearsFormatted = moment([2019, 0, 29]).fromNow().replace('years ago', '');
  const expYearsFormatted = moment([2015, 0, 29]).fromNow().replace('years ago', '');

  return (
    <section id="about" className="relative py-20 px-4 sm:px-6 lg:px-8 bg-dark-950">
      {/* Background elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/3 right-0 w-96 h-96 bg-blue-600 rounded-full mix-blend-multiply filter blur-3xl opacity-10"></div>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left side - Image/Graphic */}
          <div className="relative animate-slideUp">
            <div className="glass p-8 rounded-2xl backdrop-blur-xl">
              <div className="bg-gradient-to-br from-purple-600 via-blue-600 to-cyan-600 rounded-xl aspect-square flex items-center justify-center">
                <div className="text-6xl font-bold text-white opacity-20">S</div>
              </div>
            </div>

            {/* Floating stats */}
            <div className="absolute -bottom-10 -left-10 glass px-6 py-4 rounded-xl backdrop-blur-xl">
              <p className="text-2xl font-bold text-transparent bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text">
                {yearsFormatted}+ Years
              </p>
              <p className="text-dark-300 text-sm">{LocalizationManager.t('aboutDeliveringExcellence')}</p>
            </div>
          </div>

          {/* Right side - Content */}
          <div className="space-y-8 animate-slideUp" style={{ animationDelay: '100ms' }}>
            <div>
              <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6">
                {LocalizationManager.t('aboutUsTitle')}
              </h2>
              <p className="text-xl text-dark-300 leading-relaxed">
                {LocalizationManager.t('aboutParagraph')
                  .replace('{{years}}', yearsFormatted)
                  .replace('{{expyears}}', expYearsFormatted)}
              </p>
            </div>

            {/* Features list */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {[
                { labelKey: 'aboutProjectsCompleted', value: '200+' },
                { labelKey: 'aboutHappyClients', value: '150+' },
                { labelKey: 'aboutTeamMembers', value: '50+' },
                { labelKey: 'aboutAvgRating', value: '4.9/5' }
              ].map((stat, i) => (
                <div
                  key={i}
                  className="glass p-6 rounded-xl backdrop-blur-xl hover:backdrop-blur-2xl transition-all duration-300"
                >
                  <p className="text-3xl font-bold text-transparent bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text mb-2">
                    {stat.value}
                  </p>
                  <p className="text-dark-300 text-sm">{LocalizationManager.t(stat.labelKey)}</p>
                </div>
              ))}
            </div>

            {/* Technology badges */}
            <div>
              <h3 className="text-lg font-bold text-white mb-4">{LocalizationManager.t('aboutTechStack')}</h3>
              <div className="flex flex-wrap gap-3">
                {['React', 'Node.js', 'TypeScript', 'Cloud', 'AI/ML', 'Blockchain'].map((tech) => (
                  <span
                    key={tech}
                    className="glass px-4 py-2 rounded-full text-sm font-semibold text-purple-300"
                  >
                    {tech}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ModernAbout;
